import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nutrition-fact',
  templateUrl: './nutrition-fact.component.html',
  styleUrls: ['./nutrition-fact.component.css']
})
export class NutritionFactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
